export default "__VITE_ASSET__DjrmT23w__"